import { Observable } from 'rxjs';
import { IOfficeDto } from './../../../models/office.dto';

export abstract class OfficesContract {
  abstract get(): Observable<IOfficeDto[]>;
}
